import { useContext } from 'react';

import { DocumentContext } from '../contexts/DocumentContext';

export default () => useContext(DocumentContext);
